import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bom",
  "use": "icon-bom-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"icon-bom\">\r\n<path d=\"M14.2,18.6v83.6h39v11.2H8.6c-3.1,0-5.6-2.5-5.6-5.6l0,0V13c0-3.1,2.5-5.6,5.6-5.6h89.2c3.1,0,5.6,2.5,5.6,5.6l0,0v41.8\r\n\tH92.2V18.6H14.2z\" />\r\n<rect x=\"25.3\" y=\"29.7\" width=\"55.8\" height=\"11.2\" />\r\n<rect x=\"25.3\" y=\"52.4\" width=\"36.2\" height=\"11.2\" />\r\n<rect x=\"25.3\" y=\"75\" width=\"18.7\" height=\"11.2\" />\r\n<polygon points=\"108.9,66.2 108.9,85.3 95,91.1 81.1,85.3 81.1,66.2 95,60.4 \" />\r\n<polygon points=\"64.3,96.9 78.3,91.1 92.2,96.9 92.2,115.9 78.3,121.7 64.3,115.9 \" />\r\n<polygon points=\"111.7,91.1 125.7,96.9 125.7,115.9 111.7,121.7 97.8,115.9 97.8,96.9 \" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/bom.svg
// module id = Y7KH
// module chunks = 164